export interface HydratedItem {
  name: string
  email: string
  displayVal: string
  [key: string]: unknown
}

export const userEmailHydrator = (collection: Array<{ name: string; email: string; [key: string]: unknown }>): HydratedItem[] =>
  collection.map(item => ({
    ...item,
    displayVal: `${item.name} (${item.email})`
  }))
